// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.loopring.wallet",
    name: "Loopring",
    homepage: "https://loopring.io/",
    image_id: "2103feda-4fc8-4635-76a7-02a4ed998000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/loopring-smart-wallet/id1550921126",
        android: "https://play.google.com/store/apps/details?id=loopring.defi.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "io.loopring.wallet",
    mobile: {
        native: "loopring://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map